module.exports = __webpack_public_path__ + "assets/img/busy_4.0e250561.png";